function showResponseComment(formInfo)
{
  setResponseTopPosition(); //compute where we should display the buttons

  responseComment.value= '';

  document.getElementById("responseComment").rows = "5";
  document.getElementById("responseComment").cols = "50";
  document.getElementById("responseComment").defaultValue = "";
  document.getElementById("responseComment").removeAttribute("maxLength");
  document.getElementById("responseComment").placeholder = "";
  document.getElementById("responseComment").readOnly = false;
  document.getElementById("responseComment").required = false;
  enableEnter = 0;

  if (formInfo.responseChoices.indexOf('rows')>-1){
    document.getElementById("responseComment").rows = formInfo.responseChoices[1+formInfo.responseChoices.indexOf('rows')].toString();
  }
  if (formInfo.responseChoices.indexOf('cols')>-1){
    document.getElementById("responseComment").cols = formInfo.responseChoices[1+formInfo.responseChoices.indexOf('cols')].toString();
  }
  if (formInfo.responseChoices.indexOf('placeholder')>-1){
    document.getElementById("responseComment").placeholder = formInfo.responseChoices[1+formInfo.responseChoices.indexOf('placeholder')].toString();
  }
  if (formInfo.responseChoices.indexOf('maxLength')>-1){
    document.getElementById("responseComment").maxLength = formInfo.responseChoices[1+formInfo.responseChoices.indexOf('maxLength')].toString();
    $('textarea').keyup(updateRemaining);
    $('textarea').keydown(updateRemaining);
    document.getElementById("characters").style.top = currentButtonTop + "px";
    document.getElementById("characters").style.left = (15 + canvasWidth/2 + $('#responseComment').width()/2) + "px";
    document.getElementById("characters").style.display = "block";
  }
  if (formInfo.responseChoices.indexOf('defaultValue')>-1){
    document.getElementById("responseComment").defaultValue = formInfo.responseChoices[1+formInfo.responseChoices.indexOf('defaultValue')].toString();
  }
  if (formInfo.responseChoices.indexOf('readOnly')>-1){
    document.getElementById("responseComment").readOnly = true;
  }
  if (formInfo.responseChoices.indexOf('required')>-1){
    document.getElementById("responseComment").required = true;
  }
  if (formInfo.responseChoices.indexOf('enter')>-1){enableEnter = 1;}
  else {
    if (!trialHasButtonsActive(window.trialRow)) {
      //show only if we did not have custom buttons
      document.getElementById("buttonComment").style.top = (30 + currentButtonTop + $('#responseComment').height()) + "px";
      document.getElementById("buttonComment").style.left = (canvasWidth/2 - $('#buttonComment').width()/2) + "px";
      document.getElementById("buttonComment").style.display = "block";
    }
  }

	document.getElementById("responseComment").style.top = currentButtonTop + "px";
  document.getElementById("responseComment").style.left = (canvasWidth/2 - $('#responseComment').width()/2) + "px";
  document.getElementById("responseComment").style.display = "block";
  if (!window.inPreviewMode) {
    document.getElementById("responseComment").focus();
  }
  window.enableResponseWindowAfterMinimumDuration(disableComment, enableComment);
}

function enableComment() {
  document.getElementById("buttonComment").removeAttribute("disabled");
}

function disableComment() {
  document.getElementById("buttonComment").setAttribute("disabled", "");
}

function updateCount() {
    var cs = $(this).val().length + ' characters';
    $('#characters').text(cs);
}
function updateRemaining() {
    var cs = (document.getElementById("responseComment").maxLength - $(this).val().length) + ' characters remaining';
    $('#characters').text(cs);
}
